module.exports = __webpack_public_path__ + "static/media/stop.a1da55e6.svg";